import { useCallback, useRef } from 'react';

import { ApprovalStepState, ApprovalStepStatus } from '~/data/proposals';
import {
  CommonEmployeeProposalFormHandle,
  EmployeeProposalDecision,
} from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/Common';

export const useEmployeeProposal = () => {
  const formRef = useRef<CommonEmployeeProposalFormHandle>(null);

  const convertApprovalStepStateToDecision = (
    updatedApprovalStep: ApprovalStepState,
  ): EmployeeProposalDecision | undefined => {
    switch (updatedApprovalStep.state) {
      case ApprovalStepStatus.APPROVED:
        return EmployeeProposalDecision.Approve;
      case ApprovalStepStatus.REJECTED:
        return EmployeeProposalDecision.Reject;
      default:
        return undefined;
    }
  };

  const handleDecision = useCallback(
    (updatedApprovalStep: ApprovalStepState) => {
      // Approve or reject by submitting the related proposal form
      formRef.current?.handleSubmit(
        convertApprovalStepStateToDecision(updatedApprovalStep),
      );
    },
    [],
  );

  const handleUltimateDecision = useCallback(
    (updatedApprovalSteps: ApprovalStepState[]) => {
      // Approve or reject by submitting the related proposal form
      const decision = updatedApprovalSteps.map((step) =>
        convertApprovalStepStateToDecision(step),
      )[0];
      formRef.current?.handleSubmit(decision);
    },
    [],
  );

  return {
    handleDecision,
    handleUltimateDecision,
    formRef,
  };
};
